/**
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from './BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';

export const ECH_TYPES = {
    PLANNING_APPLICATION: 'Planning application',
    BUILDING_REQUEST: 'Building request',
    PRELIMINARY_DECISION: 'Preliminary decision',
    CONCESSION_REQUEST: 'Concession request',
    PRELIMINARY: 'preliminary',
    PERMISSION: 'permission'
};

export class ApplicationType extends BaseModel {
    public id: number | null = null;
    public bezeichnung: string | null = null;
    public ech_value: string | null = null;

    mutations(): MutationsObject {
        return {
            id: (id: number | null) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'ApplicationType';
    }
}

export class ApplicationTypeCollection extends BaseCollection<ApplicationType> {
    protected modelCls = ApplicationType;

    public getModelClassName(): string {
        return 'ApplicationType';
    }
}
